<app-update-modal *ngIf="showUpdateModal"></app-update-modal>

<main class="main-panel">
  <router-outlet></router-outlet>
</main>

<input type="hidden" id="iframeHref" value="{{ iframeHref }}" />
